import Vue from "vue";
import Router from "vue-router";
const Home = () => import("@/pages/Home");
const Index = () => import("@/pages/Index");
const Product = () => import("@/pages/Product");
const News = () => import("@/pages/News");
const About = () => import("@/pages/About");
const ProductDetail = () => import("@/pages/ProductDetail");
const NewsDetail = () => import("@/pages/NewsDetail");
const ErrorPage404 = () => import("@/pages/404");

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/",
      name: "Home",
      component: Home,
      children: [
        {
          path: "/",
          name: "Index",
          component: Index,
        },
        {
          path: "/product",
          name: "Product",
          component: Product,
        },
        {
          path: "/product/:id",
          name: "ProductDetail",
          component: ProductDetail,
        },
        {
          path: "/news",
          name: "News",
          component: News,
        },
        {
          path: "/news/:id",
          name: "NewsDetail",
          component: NewsDetail,
        },
        {
          path: "/about",
          name: "About",
          component: About,
        },
        {
          path: "/404",
          name: "404",
          component: ErrorPage404,
          meta: {
            keepalive: true,
            isTab: false,
            isAuto: false,
          },
        },
        {
          path: "*",
          redirect: "/404",
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js